export const TABLE_DIALOG_ID = 'table-expand';
